<template>
  <div class="table-container">
    <table :class="{ expandable }">
      <slot />
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  expandable?: boolean
  disableOverflow?: boolean
}>()

const scrollControllStyle = computed(() => {
  return props.disableOverflow ? 'initial' : 'auto'
})
</script>

<style lang="scss" scoped>
.table-container {
  overflow: v-bind(scrollControllStyle);
  scroll-snap-type: x mandatory;
  border-radius: 4px;
  padding-bottom: 12px;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-top: 1px solid var(--color-border-muted);
  font-size: 14px;

  :deep(> thead > tr) {
    height: 47px;
    background-color: var(--color-canvas-muted);
  }

  :deep(> thead > tr > th) {
    text-align: left;
    color: var(--color-fg-default);
    font-weight: 400;
    padding: 0 16px;
    white-space: nowrap;
    scroll-snap-align: start;

    &:first-child {
      border-left: 1px solid var(--color-border-muted);
      border-top-left-radius: 4px;
    }

    &:last-child {
      border-right: 1px solid var(--color-border-muted);
      border-top-right-radius: 4px;
    }
  }

  &.expandable {
    :deep(> tbody > tr:not(.expanded-content, .no-data)) {
      cursor: pointer;

      &:hover:not(.warn) {
        background-color: #f1f1f1;
      }
    }
  }
}
</style>
